module.exports = __webpack_public_path__ + "static/media/neevaplay.636741af.png";